<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient">
        <div class="loader-container text-center">
          <!-- Spinner -->
          <q-spinner-orbit
            color="primary"
            size="80px"
            :thickness="5"
          />
          
          <!-- Loading Text -->
          <div class="q-mt-lg">
            <h5 class="text-h5 text-weight-medium q-mb-sm">{{ loadingText }}</h5>
            <p class="text-grey-6">{{ loadingSubtext }}</p>
          </div>

          <!-- Progress Bar (opcional) -->
          <div v-if="showProgress" class="progress-container q-mt-md">
            <q-linear-progress
              :value="progress"
              color="primary"
              size="8px"
              rounded
              class="q-mb-sm"
            />
            <p class="text-caption text-grey-6">{{ Math.round(progress * 100) }}%</p>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import router from '@/router'
import store from '@/vuex/store'
import Swal from 'sweetalert2'

const loadingText = ref('Carregando...')
const loadingSubtext = ref('Por favor, aguarde')
const showProgress = ref(false)
const progress = ref(0)

onMounted(async () => {
  try {
    // Captura parâmetros da rota
    // const redirectTo = route.query.redirect || '/imoveis'
    // const action = route.query.action || null
    // const params = route.query.params ? JSON.parse(route.query.params) : {}

    // Se houver uma ação específica para executar
    
    
    await executeAction()
    console.log(router.currentRoute.value.params.token)
    sessionStorage.setItem('token', router.currentRoute.value.params.token)
    
    
    await store.dispatch('auth/getMe')
    

    // Simula progresso se showProgress for true
    if (showProgress.value) {
      await simulateProgress()
    }

    // Pequeno delay para garantir que o usuário veja o loader
    // await new Promise(resolve => setTimeout(resolve, 800))

    // Redireciona para a página de destino
    router.push({name: 'ChangePassword', query: { reset: 1 }})

  } catch (error) {
    console.error('Erro no loader:', error)
    
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Ocorreu um erro ao processar sua solicitação.',
      confirmButtonText: 'OK'
    }).then(() => {
      router.push('/login')
    })
  }
})

const executeAction = async () => {
  

      loadingText.value = 'Verificando conta...'
      loadingSubtext.value = 'Estamos confirmando a sua conta, por favor aguarde.'
}

const simulateProgress = async () => {
  const steps = 20
  const delay = 50
  
  for (let i = 0; i <= steps; i++) {
    progress.value = i / steps
    await new Promise(resolve => setTimeout(resolve, delay))
  }
}
</script>

<style scoped>
.bg-gradient {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 50%, #e8eaf6 100%);
  min-height: 100vh;
}

.loader-container {
  max-width: 400px;
  padding: 40px 20px;
}

.progress-container {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
}

h5 {
  color: #1976d2;
  margin: 0;
}
</style>